import { HttpAgent } from '@dfinity/agent'
import { Principal } from '@dfinity/principal'
import { XTCBurnParams } from '../../interfaces/walletActions'
import { XTC_CANISTER_ID } from '../../constants/canisterIds'
import getTokenActor from '../../utils/tokenActions/getTokenActor'

const burnXTC = async (params: XTCBurnParams, agent: HttpAgent) => {
  const actor = getTokenActor(XTC_CANISTER_ID, 'XTC', agent)

  if (!actor.xtc) return Promise.reject('Unable to create XTC actor')

  const burnResult = await actor.xtc.burn({
    canister_id: Principal.from(params.principal),
    amount: BigInt(params.amount),
  })

  if ('Ok' in burnResult) {
    return Number(burnResult.Ok)
  }

  if ('Err' in burnResult) {
    return Promise.reject(Object.keys(burnResult.Err)[0])
  }
}

export default burnXTC
